<template>
  <div class="footer">
    <div class="container">
      <div class="row">
        <!-- <div class="col-md-4">
          <div class="survery-deliver"> 
            <div class="copyright">
              <span>Copyright © 2019 TapApp.Cloud</span>
            </div>
          </div>
        </div>-->
        <div class="col-md-4">
          <div class="survery-deliver">
            <div class="privacy-wrap">
              <ul>
                <li>
                  <a
                    href="http://tapappcloud.com/terms-and-conditions"
                    target="_blank"
                    rel="noopener noreferrer"
                  >Terms and Conditions</a>
                </li>
                <li>
                  <a href="http://tapappcloud.com/Privacy-Policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
                </li>
                <li>
                  <a href="http://tapappcloud.com/Support" target="_blank" rel="noopener noreferrer">Support</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="survery-deliver">
            <div class="copyright">
              <span>Copyright © 2019 TapApp.Cloud</span>
            </div>
          </div>
        </div>
        <div class="col-md-5 text-right">
          <div class="survery-deliver">
            <span>
              This form is delivered by Hi-spec Services -
              <a
                href="https://tapapp.cloud/"
                target="_blank"
                rel="noopener noreferrer"
              >https://tapapp.cloud/</a>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
var { frontHostName } = require("../../../config/config.js");
export default {
  name: "Footer",
  data() {
    return {};
  },
  methods: {
    hispec() {
      // var parts = window.location.href.split(".");
      let whitelabel = this.$session.get("whitelabel");
      var loc =
        frontHostName +
        process.env.CAKE_BASE_PATH +
        whitelabel +
        process.env.CAKE_SURVEY_PATH;
      // var loc = 'http://' + location.hostname + process.env.CAKE_SURVEY_PATH
      window.location.href = loc;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/SearchResponse/Footer.vue